import Spinner from './Spinner';
import Loading from './Loading';

export { Spinner, Loading }